import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLayersSingle20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLayersSingle20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="m16.86 10-6.595-4.056a.51.51 0 0 0-.53 0L3.14 10l6.595 4.056c.162.1.367.1.53 0zm-5.8-5.324c-.65-.4-1.471-.4-2.12 0L1.382 9.324a.792.792 0 0 0 0 1.352l7.556 4.648c.65.4 1.472.4 2.12 0l7.558-4.648a.792.792 0 0 0 0-1.352z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLayersSingle20);
